import React, { useContext } from 'react'
import { AuthContext } from '../AuthContext'
import { BrowserRouter, Navigate, Route, Router, Routes } from 'react-router-dom';
import LoginPage from '../LoginPage';




import AppLayout from '../AppLayout';
import OrganizationUserSidebar from '../sidebars/FrachiseeUserSidebar';
import RequireAuth from '../RequireAuth';

import UserProfile from '../profiles/UserProfile';
import OrganizationUserRoutes from './FranchiseeUserRoutes';
import FranchiseeUserRoutes from './FranchiseeUserRoutes';
import FranchiseeUserSidebar from '../sidebars/FrachiseeUserSidebar';
import MilmaAdminSidebar from '../sidebars/MilmaAdminSidebar';
import MilmaAdminRoutes from './MilmaAdminRoutes';






const FranchiseePlatformRoutes = () => {

  const { user } = useContext(AuthContext);




  if (user === null) {

    return null;
  }

    // ** 2. ADD THE SPLIT LOGIC **
  // If the user is an admin, render the Admin routes
  if (user.is_milma_admin) {
    return (
      <Routes>
        {/*
          The /milma-admin/* prefix is handled in your main App.js (or index.js)
          so we just map the routes from here.
        */}
        <Route path="/milma-admin/*" element={<MilmaAdminRoutes />} />
        
        {/* You can keep or move the profile route as needed */}
        <Route
          path="/user/profile"
          element={
            <RequireAuth>
              <AppLayout sidebar={<MilmaAdminSidebar />}>
                <UserProfile />
              </AppLayout>
            </RequireAuth>
          }
        />
        
        {/* Fallback redirect for admin */}
        <Route path="*" element={<Navigate to="/milma-admin/home" replace />} />
      </Routes>
    );
  }

  return (



    <Routes>





        <Route
        path="/user/profile"
        element={
          <RequireAuth>
            <AppLayout sidebar={<FranchiseeUserSidebar />}>
              <UserProfile />
            </AppLayout>
          </RequireAuth>
        }
      />


     
    


     



        <Route path="/franchisee_user/*" element={<FranchiseeUserRoutes />} />
      
     




    </Routes>


  )
}

export default FranchiseePlatformRoutes
